module.exports = __webpack_public_path__ + "img/11.232e0541.gif";